import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { createSysDictionary, deleteSysDictionary as _deleteSysDictionary, updateSysDictionary, findSysDictionary, getSysDictionaryList } from "@/api/sysDictionary"; //  此处请自行替换地址
import { formatTimeToStr } from "@/utils/date";
import infoList from "@/mixins/infoList";
export default {
  name: "SysDictionary",
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getSysDictionaryList,
      dialogFormVisible: false,
      type: "",
      formData: {
        name: null,
        type: null,
        status: true,
        desc: null
      },
      rules: {
        name: [{
          required: true,
          message: "请输入字典名（中）",
          trigger: "blur"
        }],
        type: [{
          required: true,
          message: "请输入字典名（英）",
          trigger: "blur"
        }],
        desc: [{
          required: true,
          message: "请输入描述",
          trigger: "blur"
        }]
      }
    };
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time != "") {
        var date = new Date(time);
        return formatTimeToStr(date, "yyyy-MM-dd hh:mm:ss");
      } else {
        return "";
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? "是" : "否";
      } else {
        return "";
      }
    }
  },
  methods: {
    toDetile: function toDetile(row) {
      this.$router.push({
        name: "dictionaryDetail",
        params: {
          id: row.ID
        }
      });
    },
    //条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      if (this.searchInfo.status == "") {
        this.searchInfo.status = null;
      }
      this.getTableData();
    },
    updateSysDictionary: function updateSysDictionary(row) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return findSysDictionary({
                ID: row.ID
              });
            case 2:
              res = _context.sent;
              _this.type = "update";
              if (res.code == 0) {
                _this.formData = res.data.resysDictionary;
                _this.dialogFormVisible = true;
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      this.formData = {
        name: null,
        type: null,
        status: true,
        desc: null
      };
    },
    deleteSysDictionary: function deleteSysDictionary(row) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              row.visible = false;
              _context2.next = 3;
              return _deleteSysDictionary({
                ID: row.ID
              });
            case 3:
              res = _context2.sent;
              if (res.code == 0) {
                _this2.$message({
                  type: "success",
                  message: "删除成功"
                });
                if (_this2.tableData.length == 1) {
                  _this2.page--;
                }
                _this2.getTableData();
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    enterDialog: function enterDialog() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this3.$refs["elForm"].validate( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(valid) {
                  var res;
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        if (valid) {
                          _context3.next = 2;
                          break;
                        }
                        return _context3.abrupt("return");
                      case 2:
                        _context3.t0 = _this3.type;
                        _context3.next = _context3.t0 === "create" ? 5 : _context3.t0 === "update" ? 9 : 13;
                        break;
                      case 5:
                        _context3.next = 7;
                        return createSysDictionary(_this3.formData);
                      case 7:
                        res = _context3.sent;
                        return _context3.abrupt("break", 17);
                      case 9:
                        _context3.next = 11;
                        return updateSysDictionary(_this3.formData);
                      case 11:
                        res = _context3.sent;
                        return _context3.abrupt("break", 17);
                      case 13:
                        _context3.next = 15;
                        return createSysDictionary(_this3.formData);
                      case 15:
                        res = _context3.sent;
                        return _context3.abrupt("break", 17);
                      case 17:
                        if (res.code == 0) {
                          _this3.closeDialog();
                          _this3.getTableData();
                        }
                      case 18:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    openDialog: function openDialog() {
      this.type = "create";
      this.dialogFormVisible = true;
    }
  },
  created: function created() {
    var _this4 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _this4.getTableData();
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  }
};